import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import { DataAction } from '../actions'
import { fetchCurrentUser } from './actions'
import { AuthState } from './types'
import { getUserIdInToken } from './utils'

export const authReducer = combineReducers<AuthState, DataAction>({
  currentUserId: (currentUserId = getUserIdInToken(), action) => {
    switch (action.type) {
      case getType(fetchCurrentUser.success):
        return action.payload.id
      default:
        return currentUserId
    }
  },
  currentUser: (currentUser = null, action) => {
    switch (action.type) {
      case getType(fetchCurrentUser.success):
        return action.payload
      default:
        return currentUser
    }
  },
})
